module.exports = __webpack_public_path__ + "static/media/SexualHealthPregnancy.0fc5d407.svg";